<ng-template #buttonContent>
  <span class="gd-button-content" [class.reverse]="iconPosition === 'left'">
    <gd-inline-spinner *ngIf="isLoading" size="md" tone="current" />

    <!-- Label (solo variantes que no son icon-only) -->
    <span *ngIf="label && !isIconOnlyVariant" class="label">
      {{ label }}
    </span>

    <!-- Un solo icono, posición manejada por flex -->
    <mat-icon
      *ngIf="iconName && !isLoading && !isIconOnlyVariant"
      class="icon-container"
      [fontSet]="iconFontSet"
    >
      {{ iconName }}
    </mat-icon>
  </span>
</ng-template>

<ng-container [ngSwitch]="variant">
  <!-- FLAT (default) -->
  <button
    *ngSwitchCase="'flat'"
    mat-flat-button
    [matTooltip]="tooltip"
    [color]="colorType"
    [attr.type]="buttonType"
    [attr.form]="formId"
    [attr.aria-label]="ariaLabel"
    [disabled]="disabled || isLoading"
    [disabledInteractive]="isLoading"
    [attr.aria-busy]="isLoading ? 'true' : null"
    [style.min-width.px]="isLoading ? lockedMinWidth : null"
    [ngClass]="hostClasses"
    (click)="onClickButton($event)"
  >
    <ng-container *ngTemplateOutlet="buttonContent"></ng-container>
  </button>

  <!-- STROKED -->
  <button
    *ngSwitchCase="'stroked'"
    mat-stroked-button
    [matTooltip]="tooltip"
    [color]="colorType"
    [attr.type]="buttonType"
    [attr.form]="formId"
    [attr.aria-label]="ariaLabel"
    [disabled]="disabled || isLoading"
    [disabledInteractive]="isLoading"
    [attr.aria-busy]="isLoading ? 'true' : null"
    [style.min-width.px]="isLoading ? lockedMinWidth : null"
    [ngClass]="hostClasses"
    (click)="onClickButton($event)"
  >
    <ng-container *ngTemplateOutlet="buttonContent"></ng-container>
  </button>

  <!-- RAISED -->
  <button
    *ngSwitchCase="'raised'"
    mat-raised-button
    [color]="colorType"
    [matTooltip]="tooltip"
    [attr.type]="buttonType"
    [attr.form]="formId"
    [attr.aria-label]="ariaLabel"
    [disabled]="disabled || isLoading"
    [disabledInteractive]="isLoading"
    [attr.aria-busy]="isLoading ? 'true' : null"
    [style.min-width.px]="isLoading ? lockedMinWidth : null"
    [ngClass]="hostClasses"
    (click)="onClickButton($event)"
  >
    <ng-container *ngTemplateOutlet="buttonContent"></ng-container>
  </button>

  <!-- ICON ONLY -->
  <button
    *ngSwitchCase="'icon'"
    mat-icon-button
    [color]="colorType"
    [matTooltip]="tooltip"
    [attr.type]="buttonType"
    [attr.form]="formId"
    [attr.aria-label]="ariaLabel"
    [disabled]="disabled || isLoading"
    [disabledInteractive]="isLoading"
    [attr.aria-busy]="isLoading ? 'true' : null"
    [style.min-width.px]="isLoading ? lockedMinWidth : null"
    [ngClass]="hostClasses"
    (click)="onClickButton($event)"
  >
    <gd-inline-spinner *ngIf="isLoading" size="md" tone="current" />

    <mat-icon
      *ngIf="!isLoading && iconName"
      class="icon-container"
      [fontSet]="iconFontSet"
    >
      {{ iconName }}
    </mat-icon>
  </button>

  <!-- MINI FAB ICON -->
  <button
    *ngSwitchCase="'mini-fab'"
    mat-mini-fab
    [color]="colorType"
    [matTooltip]="tooltip"
    [attr.type]="buttonType"
    [attr.form]="formId"
    [attr.aria-label]="ariaLabel"
    [disabled]="disabled || isLoading"
    [disabledInteractive]="isLoading"
    [attr.aria-busy]="isLoading ? 'true' : null"
    [style.min-width.px]="isLoading ? lockedMinWidth : null"
    [ngClass]="hostClasses"
    (click)="onClickButton($event)"
  >
    <gd-inline-spinner *ngIf="isLoading" size="md" tone="current" />

    <mat-icon
      *ngIf="!isLoading && iconName"
      class="icon-container"
      [fontSet]="iconFontSet"
    >
      {{ iconName }}
    </mat-icon>
  </button>

  <!-- BASIC / fallback -->
  <button
    *ngSwitchDefault
    mat-button
    [color]="colorType"
    [matTooltip]="tooltip"
    [attr.type]="buttonType"
    [attr.form]="formId"
    [attr.aria-label]="ariaLabel"
    [disabled]="disabled || isLoading"
    [disabledInteractive]="isLoading"
    [attr.aria-busy]="isLoading ? 'true' : null"
    [style.min-width.px]="isLoading ? lockedMinWidth : null"
    [ngClass]="hostClasses"
    (click)="onClickButton($event)"
  >
    <ng-container *ngTemplateOutlet="buttonContent"></ng-container>
  </button>
</ng-container>
